export const initArticleTitleScale = () => {
    const articleTitle = document.querySelector<HTMLElement>(
        '[data-selector="article-title"]',
    );
    if (!articleTitle) return;

    const MAX_SCROLL = 300; 
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const isTablet = window.matchMedia("(min-width: 768px)").matches;
    const MIN_SCALE = isDesktop ? 0.65 : isTablet ? 0.75 : 1;

    let ticking = false;

    const onScroll = () => {
        const scrollY = Math.min(window.scrollY, MAX_SCROLL);
        const scale = 1 - (1 - MIN_SCALE) * (scrollY / MAX_SCROLL);
        articleTitle.style.transform = `scale(${scale})`;
    };

    window.addEventListener("scroll", () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                onScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    onScroll();
};
